export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      5275.283446712018,
    ],
    button_spin: [
      7000,
      802.5396825396829,
    ],
    end_free_spin: [
      9000,
      2001.269841269842,
    ],
    free_bet_big_win: [
      13000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      16000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      20000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      22000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      25000,
      34607.89115646259,
    ],
    free_spin_music: [
      61000,
      52363.90022675738,
    ],
    free_spin_start: [
      115000,
      6787.482993197273,
    ],
    inside_buttons: [
      123000,
      242.35827664399778,
    ],
    main_ambient: [
      125000,
      72534.78458049886,
    ],
    main_music: [
      199000,
      178922.8117913832,
    ],
    mega_win: [
      379000,
      5173.6961451247225,
    ],
    outside_buttons: [
      386000,
      314.92063492061106,
    ],
    reel_spin: [
      388000,
      2414.8752834466904,
    ],
    reel_stop_01: [
      392000,
      195.91836734696244,
    ],
    reel_stop_02: [
      394000,
      181.40589569162557,
    ],
    reel_stop_03: [
      396000,
      213.33333333330984,
    ],
    reel_stop_04: [
      398000,
      233.65079365078145,
    ],
    reel_stop_05: [
      400000,
      233.65079365078145,
    ],
    regular_win: [
      402000,
      695.1473922902665,
    ],
    scatter_bomb_explosion: [
      404000,
      2741.405895691628,
    ],
    scatter_stop: [
      408000,
      1043.446712018124,
    ],
    select_free_spin: [
      411000,
      8941.13378684807,
    ],
    tap_to_play: [
      421000,
      3765.9863945578422,
    ],
    ultra_win: [
      426000,
      5118.548752834442,
    ],
  },
}
